import { CountriesEnum, CountriesQuery, CountryData, CountryObject, LocalesEnum } from 'src/generated/operations';
import { isEnum } from 'src/utils/isEnum';
import { defaultUserSettings } from 'src/bootstrap/constants';

export function getCountryCodeOrDefault(input: string): CountriesEnum {
    if (!!input && isEnum(input, CountriesEnum)) {
        return input as CountriesEnum;
    }
    return defaultUserSettings.currentCountry;
}

export function getCountryData(country: string, countries: CountriesQuery) {
    return countries.countries.find((item) => item.code === country) as CountryObject;
}

export function getLocale(countryData: CountryData, language: string): LocalesEnum {
    const localeData = countryData.locales
        .find(({ locale }) => locale.substring(0, 2) === language.substring(0, 2));
    if (localeData) {
        return localeData.locale;
    }
    const [{ locale }] = countryData.locales;
    return locale;
}
